// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Mem$Showside from "../utils/Mem.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as IconButton$Showside from "./IconButton.bs.js";
import * as FiltersField$Showside from "./FiltersField.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as FiltersConfig2$Showside from "../types/FiltersConfig2.bs.js";
function makeFromConfig(includeCountZeroOpt, countMap, appliedFilters, allSections, section) {
  var includeCountZero = includeCountZeroOpt !== undefined ? includeCountZeroOpt : false;
  var getValue = Mem$Showside.memWithCacheKey(function (facet) {
    return Belt_Option.mapWithDefault(appliedFilters, false, function (facets) {
      return Belt_Array.some(facets.entries, function (param) {
        return param.facet === facet;
      });
    });
  }, function (facet) {
    return [facet, appliedFilters];
  });
  var getIndex = Mem$Showside.mem(function (facet) {
    var currentSectionIndex = Belt_Array.getIndexBy(allSections, function (s) {
      return FiltersConfig2$Showside.Section.getId(s) === FiltersConfig2$Showside.Section.getId(section);
    });
    if (currentSectionIndex !== undefined) {
      return Belt_Array.reduce(Belt_Array.slice(allSections, 0, currentSectionIndex + 1 | 0), 0, function (acc, currentSection) {
        if (FiltersConfig2$Showside.Section.getId(currentSection) !== FiltersConfig2$Showside.Section.getId(section)) {
          return acc + FiltersConfig2$Showside.Section.getOptions(currentSection).length | 0;
        } else {
          return acc + Belt_Option.getWithDefault(Belt_Array.getIndexBy(FiltersConfig2$Showside.Section.getOptions(currentSection), function (option) {
            return option.facet === facet;
          }), 0) | 0;
        }
      });
    } else {
      return 0;
    }
  });
  var getCount = Mem$Showside.memWithCacheKey(function (facet) {
    return Belt_Option.getWithDefault(Js_dict.get(Js_dict.fromArray(Belt_Array.keep(countMap, function (param) {
      return param[1] > 0;
    })), facet), 0);
  }, function (facet) {
    return [facet, countMap];
  });
  var options = Belt_Array.map(Belt_Array.keepMap(FiltersConfig2$Showside.Section.getOptions(section), function (option) {
    var count = Curry._1(getCount, option.facet);
    var value = Curry._1(getValue, option.facet);
    var index = Curry._1(getIndex, option.facet);
    var disabled = count === 0 && !value;
    if (count > 0 || includeCountZero) {
      return [option, count, value, index, disabled];
    }
  }), function (param) {
    var option = param[0];
    return {
      id: option.id,
      index: param[3],
      facet: option.facet,
      label: option.label,
      swatch: option.value,
      value: param[2],
      count: param[1],
      disabled: param[4]
    };
  });
  var label = FiltersConfig2$Showside.Section.getLabel(section);
  var id = FiltersConfig2$Showside.Section.getId(section);
  var style;
  switch (section.TAG | 0) {
    case /* ColorCheckbox */0:
      style = /* ColorCheckbox */0;
      break;
    case /* ImageCheckbox */1:
      style = /* ImageCheckbox */2;
      break;
    case /* Checkbox */2:
      style = /* Checkbox */1;
      break;
  }
  var visible = FiltersConfig2$Showside.Section.isVisible(section);
  return {
    label: label,
    id: id,
    options: options,
    style: style,
    visible: visible
  };
}
function FiltersSection(Props) {
  var section = Props.section;
  var disableAllOpt = Props.disableAll;
  var showLabelOpt = Props.showLabel;
  var canCollapseOpt = Props.canCollapse;
  var maxInRowOpt = Props.maxInRow;
  var borderOpt = Props.border;
  var onChange = Props.onChange;
  var onChecked = Props.onChecked;
  var onUnchecked = Props.onUnchecked;
  var renderAfter = Props.renderAfter;
  var renderIcon = Props.renderIcon;
  var highlightSelectedOptionsOpt = Props.highlightSelectedOptions;
  var autoFocusOpt = Props.autoFocus;
  var largeOpt = Props.large;
  var fullscreenOpt = Props.fullscreen;
  var classNameOpt = Props.className;
  var rtlOpt = Props.rtl;
  var sectionIdPrefixOpt = Props.sectionIdPrefix;
  var disableAll = disableAllOpt !== undefined ? disableAllOpt : false;
  var showLabel = showLabelOpt !== undefined ? showLabelOpt : true;
  var canCollapse = canCollapseOpt !== undefined ? canCollapseOpt : true;
  var maxInRow = maxInRowOpt !== undefined ? maxInRowOpt : 4;
  var border = borderOpt !== undefined ? borderOpt : true;
  var highlightSelectedOptions = highlightSelectedOptionsOpt !== undefined ? highlightSelectedOptionsOpt : false;
  var autoFocus = autoFocusOpt !== undefined ? autoFocusOpt : false;
  var large = largeOpt !== undefined ? largeOpt : false;
  var fullscreen = fullscreenOpt !== undefined ? fullscreenOpt : false;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var rtl = rtlOpt !== undefined ? rtlOpt : false;
  var sectionIdPrefix = sectionIdPrefixOpt !== undefined ? sectionIdPrefixOpt : "filters";
  var match = React.useState(function () {
    return true;
  });
  var setExpanded = match[1];
  var expanded = match[0];
  var match$1 = React.useState(function () {
    return false;
  });
  var setShowSecondHalf = match$1[1];
  var showSecondHalf = match$1[0];
  var getInitialFocusedCheckbox = function (param) {
    return Belt_Option.getWithDefault(Belt_Array.getIndexBy(section.options, function (param) {
      return param.value;
    }), 0);
  };
  var match$2 = React.useState(function () {
    return getInitialFocusedCheckbox(undefined);
  });
  var setLastFocusedCheckbox = match$2[1];
  var lastFocusedCheckbox = match$2[0];
  React.useEffect(function () {
    Curry._1(setLastFocusedCheckbox, function (prev) {
      if (autoFocus) {
        return prev;
      } else {
        return getInitialFocusedCheckbox(undefined);
      }
    });
  }, [autoFocus]);
  var options = section.options;
  var selected = React.useMemo(function () {
    return Belt_Array.keep(options, function (facet) {
      return facet.value;
    }).length;
  }, [options]);
  var isRadio = section.style === /* Radio */5;
  var isGrid = section.style === /* ButtonCheckbox */3 || section.style === /* ColorCheckbox */0 || section.style === /* ImageCheckbox */2;
  var canCollapse$1 = canCollapse && !isGrid;
  var options$1 = Belt_Array.mapWithIndex(options, function (idx, facet) {
    if (!isRadio) {
      return facet;
    }
    var isLast = function (param) {
      var sliced = Belt_Array.sliceToEnd(options, idx + 1 | 0);
      return Belt_Array.keep(sliced, function (i) {
        return i.value;
      }).length !== 0;
    };
    if (facet.value) {
      return {
        id: facet.id,
        index: facet.index,
        facet: facet.facet,
        label: facet.label,
        swatch: facet.swatch,
        value: !isLast(undefined),
        count: facet.count,
        disabled: facet.disabled
      };
    } else {
      return facet;
    }
  });
  var updateValue = function (index, newValue) {
    var options$2 = isRadio ? Belt_Array.map(options$1, function (facet) {
      return {
        id: facet.id,
        index: facet.index,
        facet: facet.facet,
        label: facet.label,
        swatch: facet.swatch,
        value: false,
        count: facet.count,
        disabled: facet.disabled
      };
    }) : options$1;
    var options$3 = Belt_Array.mapWithIndex(options$2, function (idx, facet) {
      var value = idx === index ? newValue : facet.value;
      return {
        id: facet.id,
        index: facet.index,
        facet: facet.facet,
        label: facet.label,
        swatch: facet.swatch,
        value: value,
        count: facet.count,
        disabled: facet.disabled
      };
    });
    Belt_Option.forEach(onChange, function (onChange) {
      Curry._1(onChange, options$3);
    });
  };
  var onChecked$1 = function (i) {
    Belt_Option.forEach(onChecked, function (onChecked) {
      Belt_Option.forEach(Belt_Array.get(options$1, i), onChecked);
    });
    updateValue(i, true);
  };
  var onUnchecked$1 = function (i) {
    Belt_Option.forEach(onUnchecked, function (onUnchecked) {
      Belt_Option.forEach(Belt_Array.get(options$1, i), onUnchecked);
    });
    updateValue(i, false);
  };
  var options$2 = Belt_Array.mapWithIndex(options$1, function (idx, facet) {
    var tmp = {
      id: facet.id,
      index: idx,
      value: facet.value,
      label: facet.label,
      count: facet.count,
      style: section.style,
      isRadio: isRadio,
      isGrid: isGrid,
      onChecked: onChecked$1,
      onUnchecked: onUnchecked$1,
      onFocus: function (i) {
        Curry._1(setLastFocusedCheckbox, function (param) {
          return i;
        });
      },
      disabled: facet.disabled || disableAll,
      highlight: highlightSelectedOptions,
      rtl: rtl,
      autoFocus: idx === lastFocusedCheckbox && autoFocus,
      large: large,
      sectionIdPrefix: sectionIdPrefix,
      key: facet.id
    };
    if (facet.swatch !== undefined) {
      tmp.swatch = facet.swatch;
    }
    var tmp$1 = Belt_Option.map(renderIcon, function (fn) {
      return Curry._1(fn, facet);
    });
    if (tmp$1 !== undefined) {
      tmp.customIcon = Caml_option.valFromOption(tmp$1);
    }
    return React.createElement(FiltersField$Showside.Checkbox.make, tmp);
  });
  var firstHalf = Belt_Array.keepWithIndex(options$2, function (checkbox, idx) {
    if (idx < maxInRow || options$2.length < maxInRow) {
      return true;
    } else {
      return !canCollapse$1;
    }
  });
  var secondHalf = Belt_Array.keepWithIndex(options$2, function (checkbox, idx) {
    if (idx >= maxInRow && options$2.length >= maxInRow) {
      return canCollapse$1;
    } else {
      return false;
    }
  });
  var match$3 = secondHalf.length;
  var match$4 = match$3 !== 1 ? [firstHalf, secondHalf] : [options$2, []];
  var secondHalf$1 = match$4[1];
  var className$1 = CSS$Showside.prefix(Cn.make([isGrid ? "grid" : "flex flex-col", expanded ? "h-auto -m-2 p-2" : "h-0 my-0", expanded && isGrid ? "-ml-4" : "", expanded ? "" : "overflow-hidden"]));
  var match$5 = options$2.length;
  if (match$5 !== 0) {
    return React.createElement(DataAttribute$Showside.make, {
      dataTestId: "filters-section",
      dataSectionId: "" + sectionIdPrefix + "-label",
      children: React.createElement("div", {
        "aria-expanded": expanded,
        "aria-labelledby": section.id + "-label",
        className: className,
        id: section.id,
        role: "group"
      }, border ? React.createElement("div", {
        className: CSS$Showside.prefix("border-t border-primary opacity-5")
      }) : null, showLabel ? React.createElement(DataAttribute$Showside.make, {
        dataActive: expanded,
        dataTestId: "filters-collapsible",
        children: React.createElement("div", {
          "aria-controls": section.id,
          className: CSS$Showside.prefix("flex w-full items-center no-touch-highlight py-4 cursor-pointer"),
          role: "button",
          tabIndex: 0,
          onClick: function (param) {
            Curry._1(setExpanded, function (param) {
              return !expanded;
            });
          }
        }, React.createElement("div", {
          className: CSS$Showside.prefix("flex-grow text-lg text-secondary"),
          id: section.id + "-label"
        }, section.label, selected > 0 && !isRadio ? " (" + String(selected) + ")" : null), React.createElement(IconButton$Showside.make, {
          clear: true,
          iconSize: /* Smallest */4,
          labelSize: /* Smallest */4,
          icon: React.createElement(Unicons$Showside.UilAngleLeftB.make, {}),
          iconClassName: CSS$Showside.prefix((expanded ? "rotate-90" : "-rotate-90") + " scale-105 transform-gpu transition-transform duration-75"),
          className: CSS$Showside.prefix("text-accent"),
          tabIndex: -1
        }))
      }) : null, React.createElement("div", {
        "aria-hidden": !expanded,
        className: className$1,
        role: "tabpanel",
        style: {
          gridTemplateColumns: fullscreen ? "repeat(auto-fill, minmax(82px, max-content))" : "repeat(auto-fill, minmax(48px, max-content))"
        }
      }, match$4[0], showSecondHalf ? secondHalf$1 : null, secondHalf$1.length !== 0 && canCollapse$1 ? React.createElement("div", {
        className: CSS$Showside.prefix("mb-4 mt-2")
      }, React.createElement(DataAttribute$Showside.make, {
        dataActive: showSecondHalf,
        dataTestId: "filters-show-more-button",
        children: React.createElement("div", {
          "aria-label": showSecondHalf ? "see less" : "see " + String(secondHalf$1.length) + " more",
          className: CSS$Showside.prefix("inline-block cursor-pointer text-tertiary text-base underline inline-block no-touch-highlight"),
          role: "button",
          onClick: function (param) {
            Curry._1(setShowSecondHalf, function (param) {
              return !showSecondHalf;
            });
          }
        }, showSecondHalf ? "See Less" : "See More")
      })) : null, Belt_Option.getWithDefault(renderAfter, null)))
    });
  } else {
    return null;
  }
}
FiltersSection.displayName = "FiltersSection";
var make = FiltersSection;
export { makeFromConfig, make };
/* react Not a pure module */